// extracted by mini-css-extract-plugin
module.exports = {"permitContainer":"Desktop_permitContainer__y4pu7"};